import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "../../../components";

const LabelWithTooltip = props => {
	const { content, tooltipMessage } = props;
	return (
		<div className="col-xs-12">
			{content}
			<Tooltip content={tooltipMessage}>
				<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
			</Tooltip>
		</div>
	);
};

LabelWithTooltip.propTypes = {
	content: PropTypes.string.isRequired,
	tooltipMessage: PropTypes.string.isRequired,
};

export default LabelWithTooltip;
